import axios from 'axios';
import cfg from '../../config.json';
export const $axiosL = axios.create();

$axiosL.defaults.timeout = 60000;

// Interceptor when requesting http
$axiosL.interceptors.request.use(function (config) {
    document.querySelector('.spinner-box').classList.add('show');
    config.headers.Credentials = 'dirineo';
    if (cfg.request_timeout > 0) {
        config.timeout = cfg.request_timeout * 1000; // in seconds
    }
    return config;
});

//Interceptor after response

$axiosL.interceptors.response.use(function (response) {
    document.querySelector('.spinner-box').classList.remove('show');
    return response;
}, function (error) {
    document.querySelector('.spinner-box').classList.remove('show');
    return Promise.reject(error)
}
);

//Interceptor after request error